import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import fetch from '../../assets/images/fetch.svg'
import update from '../../assets/images/update.svg'
import generate from '../../assets/images/generate.svg'
import log from '../../assets/images/log.svg'
import updateDisable from '../../assets/images/updateDisable.svg'
import EditIcon from '../../assets/images/EditIcon2.svg'
import generateDisable from '../../assets/images/generateDisable.svg'
import historyDisable from '../../assets/images/historyDisable.svg'
import Api from "../../state/Api";
import EntityApi from "../../state/entity-api";
import { bookingsStore, configStore, creditControlStore, hblDetailsStore } from "../../state/CommonState";
import { myactionsstore } from "../../my-actions/store-myactions";
import RoleUtils from "../../util/RoleUtils";
import { PERMISSIONS_NEW } from "../../util/constants";
import Utils from "../../util/Utils";
import { isEqual } from "lodash";
import { useSnapshot } from "valtio";
import { loader } from "../../util/loader"

export function BlLadingForm() {
    useSnapshot(myactionsstore)
    useSnapshot(creditControlStore)

    useEffect(() => {
        if (!creditControlStore.list || creditControlStore.list.length === 0) {
            EntityApi.getCreditControl()
        }
    }, [])
    const [results,setResults] = useState()
    const [open, setOpen] = useState(false)
    const [openPopup, setOpenPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [statusArray, setStatusArray] = useState([]);
    const [enableButton,setEnableButton] = useState(true)
    const [count, setCount] = useState(0)
    const [finalEditable, setFinalEditable] = useState(false)
    const [type, setType] = useState("")
    const [transhipment,setTranshipment] = useState("")
    
    const onSubmit = async (data,action) => {
        console.log(data, "checking for dataaaa");
        let payload = {
            blData: data,
            goods: data.goods
        }
        if(payload.blData.status === 'Draft') payload.blData.blType = ""
        if (payload.blData.status === 'Final') {
            const entityId = bookingsStore.current?.contract?.entityId || bookingsStore.current?.entityId || myactionsstore?.list?.[0]?.booking?.entityId || myactionsstore?.list?.[0]?.Entities?._id;
            const shipmentType = bookingsStore.current?.contract?.shipmentType || bookingsStore.current?.shipmentType || myactionsstore?.list?.[0]?.shipmentType;
            if (creditControlStore.isHoldBLDO(entityId, shipmentType)) {
                loader.hide();
                configStore.setModalMessage("Finance Hold is applicable for BL/DO release", [], false);
                return;
            }
        }
        if(!enableButton){
            if (action === 'Save') {
                loader.show()
                if (payload.blData.status == 'Final' || payload.blData.status == '') {
                    const draftCheck = results && results?.some(e => e.blData.status == 'Draft' && e.blData.type == "Generated")
                    if (!draftCheck) {
                        loader.hide()
                        setPopupMessage("No Draft has been generated yet. Please get the draft approved before generating final BL.");
                        setOpenPopup(true);
                        return;
                    }
                }
                payload.blData.type = "Generated"
                let downloadURL = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/downloadBL`
                hblDetailsStore.current = payload
                const response = await Api.fetchFile1(downloadURL, payload)
                const pdfBlob = new Blob([response], {
                    type: "application/pdf",
                });
                const url = window.URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${payload.blData.status.toUpperCase()}-${bookingsStore.current.erpBookingId}`);
                document.body.appendChild(link);
                link.click();
                loader.hide()
                setCount(prev => prev + 1)
                // configStore.blDetails = false
                // reset()
            } else {
                loader.show()
                payload.blData.type = "Save"
                // if (hblDetailsStore.current?.blData) hblDetailsStore.current.blData.status = ""
                const isBlDataEqual = isEqual(payload.blData,hblDetailsStore.current.blData);
                const isGoodsEqual = isEqual(payload.goods, hblDetailsStore.current.goods);

                if (isBlDataEqual && isGoodsEqual) {
                    loader.hide()
                    configStore.setModalMessage("Looks like nothing changed.")
                }else{
                    if (hblDetailsStore.current._id && hblDetailsStore.current.blData.type == "Save") payload._id = hblDetailsStore.current._id
                    Api.updateBlDetails(payload, (data) => {
                        loader.hide()
                        configStore.setModalMessage(data.message)
                        hblDetailsStore.current = JSON.parse(JSON.stringify(data.result))
                    })
                }
            }
        }
    }
    useEffect(() => {
        const getUNLOC = async () => {
            if(myactionsstore?.list[0]?.reworking_pol_port){
                Api.get4Unloc(myactionsstore.list[0].reworking_pol_port,setTranshipment)
            }
        }
        getUNLOC()
        if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.HBL_FINAL)) {
            setStatusArray(["Draft", "Final"]);
        } else {
            setStatusArray(["Draft"]);
        }
    }, []);
    
    useEffect(()=>{
        Api.getBLDetails(bookingsStore.current._id, (data) => {
            console.log(data, "sdfdsfdsfsdfds");
            if (data.length > 0){
                console.log(data[data.length - 1],"43545345345345");
                setResults(data)
                setEnableButton(false)
                hblDetailsStore.current = data[data.length - 1]
                console.log(hblDetailsStore.current, "43545345345345 stooree",hblDetailsStore.current);

                if (data?.length > 0) {
                    setValue('referenceNo', hblDetailsStore.current.blData.referenceNo)
                    setValue('placeOfAcceptance', hblDetailsStore.current.blData.placeOfAcceptance)
                    setValue('pol', hblDetailsStore.current.blData.pol)
                    setValue('pod', hblDetailsStore.current.blData.pod)
                    setValue('fpod', hblDetailsStore.current.blData.fpod)
                    setValue("dateAndPlaceOfIssue", hblDetailsStore.current.blData.dateAndPlaceOfIssue);
                    setValue('transhipment', hblDetailsStore.current.blData.transhipment)
                    setValue('vessel', hblDetailsStore.current.blData.vessel)
                    setValue('voyage', hblDetailsStore.current.blData.voyage)
                    setValue('notifyParty1', hblDetailsStore.current.blData.notifyParty1)
                    // setValue('notifyParty2', hblDetailsStore.current.blData.notifyParty2)
                    setValue('consigneeAddress', hblDetailsStore.current.blData.consigneeAddress)
                    setValue('consignorAddress', hblDetailsStore.current.blData.consignorAddress)
                    setValue('destinationAddress', hblDetailsStore.current.blData.destinationAddress)
                    setValue('blType', hblDetailsStore.current?.blData?.blType || '')
                    setValue('sob', hblDetailsStore.current?.blData?.sob || '')
                    setValue('hblDate', hblDetailsStore.current?.blData?.hblDate || '')
                    setValue('mtdNo', hblDetailsStore.current.blData.mtdNo)
                    setValue('mtoNo', hblDetailsStore.current.blData.mtoNo)
                    setValue('status', hblDetailsStore.current.blData.status)
                    // setValue('additionalClauses', hblDetailsStore.current.blData.additionalClauses)
                    setValue('originalMtd', hblDetailsStore.current.blData.originalMtd)
                    // setValue('signed', hblDetailsStore.current.blData.signed)
                    // setValue('freightAmount', hblDetailsStore.current.blData.freightAmount)
                    // setValue('otherDetails', hblDetailsStore.current.blData.otherDetails)
                    // setValue('particulars', hblDetailsStore.current.blData.particulars)
                    setValue('movement', hblDetailsStore.current.blData.movement)
                    setValue('mode', hblDetailsStore.current.blData.mode)
                    // setValue('doa', hblDetailsStore.current.blData.doa)
                    // setValue('deliveryDate', hblDetailsStore.current.blData.deliveryDate)
                    hblDetailsStore.current.goods.forEach((item, index) => {
                        setValue(`goods.${index}.marks`, item.marks);
                        setValue(`goods.${index}.packages`, item.packages);
                        setValue(`goods.${index}.description`, item.description);
                        setValue(`goods.${index}.grossWeight`, item.grossWeight);
                        setValue(`goods.${index}.measurement`, item.measurement);
                    });
                }
                if(hblDetailsStore.current?.blData?.status === 'Final' && hblDetailsStore.current?.blData?.type === "Generated"){
                    setFinalEditable(true)
                }
            }
        })
    }, [count])
    const blForm = useForm({
        defaultValues: {
            // format:"templated_data",
            status:"Draft",
            consignorAddress: "",
            consigneeAddress: "",
            notifyParty1: "",
            // notifyParty2: "",
            referenceNo: bookingsStore.current._id,
            placeOfAcceptance: "",
            mtdNo: "",
            vessel:"",
            voyage: "",
            pol: "",
            pod: "",
            fpod: "",
            transhipment: "",
            movement: "",
            // doa: "",
            // deliveryDate: "",
            mode: "SEA",
            destinationAddress: "",
            // otherDetails: "",
            mtdCount: "",
            // freightAmount: "",
            dateAndPlaceOfIssue: "",
            hblDate: "",
            sob: "",
            blType: "",
            mtoNo: "",
            // additionalClauses: "",
            originalMtd: "0 (Zero)",
            // signed: "",
            goods: [
                {
                    marks: "",
                    packages: "",
                    description: "",
                    grossWeight: "",
                    measurement: ""
                }
            ]
        }
    })
    const {
        register,
        handleSubmit,
        control,
        setValue,
        reset,
        watch,
        clearErrors,
        formState: { errors },
    } = blForm
    const { fields, append, remove } = useFieldArray({
        control,
        name: "goods",
    });
    const box = {
        border: "1px solid #E8E8E8",
        minHeight: "110px",
        display: "flex",
        flexDirection: "column",
    };

    const header = {
        background: "#EFF5FF",
        fontSize: "13px",
        padding: "6px 8px",
        color: '#2B3688',
        fontWeight: '600',
        fontFamily:'figtree'
    };

    const input = {
        flex: 1,
        border: "none",
        outline: "none",
        padding: "8px",
    };

    const textarea = {
        flex: 1,
        border: "none",
        resize: "none",
        outline: "none",
        padding: "8px",
        height:'30px'
    };
    // const container = {
    //     display: "flex",
    //     flexDirection: "column",
    //     width: "100%",
    //     borderRadius: "6px",
    //     backgroundColor: "white",
    //     boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    //     padding: "18px",
    //     gap: "18px",
    //     marginTop: "5px"
    // };

    const container = {
        position: "fixed",
        inset: 0,
        top: "50px",
        borderRadius: "6px",
        backgroundColor: "white",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        padding: "18px",
        gap: "18px",
        marginTop: "5px"
    }

    const row = { display: "flex", height:'15%' };
    const options = [
      { value:"", label: "Select a value" },
      { value: "0 (Zero)", label: "0 (Zero)" },
    ];

    if (watch("blType") === "Original") {
        options.push(
            { value: "1 (One)", label: "1 (One)" },
            { value: "2 (Two)", label: "2 (Two)" },
            { value: "3 (Three)", label: "3 (Three)" }
        );
    }
    const Field = ({headerStyle,disabled=finalEditable, label, name, type = "input", style = {} }) => (
        <div style={{ ...box, flex: 1, ...style }}>
            <div style={{...header,...headerStyle}}>{label}</div>
            {type === "textarea" ? (
                <textarea {...register(name)}
                disabled={disabled} style={textarea} />
            ) :type === "dropdown" ? (
                <select
                  {...register(name, {
                      validate: value => {
                        if (watch("status") === "Final" && name === 'originalMtd' && !value) {
                          return "Original MTD is required";
                        }
                        return true;
                      }
                })}
                  disabled={disabled}
                  style={{
                    width: "100%",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    // background: "transparent",
                    border: errors[name]
                        ? "1px solid red"
                        : "1px solid #DDDDDD"
                }}>
                  {options.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
            ) :(
                <input {...register(name)} disabled={disabled} style={input} />
            )}
        </div>
    );
    let status = watch('status')
    let blType = watch('blType')

    const packages = {
        "Packages":`Package(s)`,
        "Pallet":`Pallet(s)`,
        "Drum":`Drum(s)`,
        "Crate":`Crate(s)`,
        "Skid":`Skid(s)`,
        "Loose Cartons":`Loose Carton(s)`,
        "Box":`Box(s)`,
        "Bales":`Bale(s)`,
        "Rolls":`Roll(s)`,
        "Cartons":`Carton(s)`
    }
    return (<>
        
        <div style={container}>
            {open && <LogHistory onClose={setOpen} data={results} />}
            {openPopup && <Popup onClose={setOpenPopup} message={popupMessage} type={type} finalEditable={setFinalEditable}/>}
            <div style={{ display: 'flex', justifyContent: 'space-between',gap:'10px' }}>
                <h4 className="title">HBL Details</h4>
                {/* <div style={{ marginLeft: 'auto' }}>
                    <select {...register('format')} style={{
                        width: '150px',
                        padding: '6px 10px',
                        border: '1px solid #DDDDDD'
                    }}>
                        <option value='templated_data'>Templated Data</option>
                        <option value='plain_data'>Plain Data</option>
                    </select>
                </div> */}
                <button style={{ float: 'right' }} className="button is-small islink"
                    onClick={async (e) => {
                        configStore.blDetails = false
                    }}>
                    <span className="icon ">
                        <i className="fas fa-xmark"></i>
                    </span>
                </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div style={{
                    height: '25vh',
                    backgroundColor: '#EFF5FF',
                    marginBottom: '10px',
                    borderRadius: '6px'
                }}>

                    <div style={{
                        display: 'flex',
                        padding: '20px 40px',
                        gap: '30px',
                        alignItems: "center"
                    }}>
                        <div onClick={async () => {  
                            loader.show() 
                            setEnableButton(false)
                            console.log(hblDetailsStore.current,"hblstor");
                            const cargoTotals = [bookingsStore.current.contract.cargoTotals]
                            const destinationAddress = [bookingsStore.current.contract?.agentDetails, bookingsStore.current.contract?.agentAddress].filter(Boolean).join("\n") || ""
                                const today = new Date().toISOString().split("T")[0].split("-").reverse().join("-");
                                setValue('referenceNo', bookingsStore.current._id)
                                setValue('placeOfAcceptance', bookingsStore.current.contract.portOfReceipt.replace(/\s*\(.*?\)/g, ""))
                                setValue('pol', bookingsStore.current.contract.portOfLoading.replace(/\s*\(.*?\)/g, ""))
                                setValue('pod', bookingsStore.current.contract.portOfDischarge.replace(/\s*\(.*?\)/g, ""))
                                setValue('fpod', bookingsStore.current.contract.finalPlaceOfDelivery.replace(/\s*\(.*?\)/g, ""))
                                setValue('dateAndPlaceOfIssue', `${today} (Mumbai)`);
                                setValue('transhipment', Utils.formatLocation(transhipment))
                                setValue("vessel", myactionsstore.list?.[0]?.fl_vessel_name);                                
                                setValue("voyage", myactionsstore.list?.[0]?.fl_vessel_number);                                
                                setValue('notifyParty1', Utils.concatAddress(bookingsStore.current?.invoiceDetails?.notifyParty1))
                                setValue('hblDate',new Date().toISOString().split("T")[0])
                                // setValue('notifyParty2', bookingsStore.current?.invoiceDetails?.notifyParty2?.name)
                                setValue('consigneeAddress', Utils.concatAddress(bookingsStore.current?.invoiceDetails?.importer))
                                setValue('consignorAddress', Utils.concatAddress(bookingsStore.current?.invoiceDetails?.exporter))
                                setValue('sob', myactionsstore.list[0].sob_pol)
                                setValue('movement',bookingsStore.current?.shippingDetails?.serviceCode)
                                setValue('mtdNo',bookingsStore.current.erpBookingId)
                                setValue('destinationAddress',destinationAddress)
                                cargoTotals.forEach((item, index) => {
                                    const notifyParty2 = Utils.concatAddress(bookingsStore.current?.invoiceDetails?.notifyParty2 || "");
                                    const descriptionText = `${bookingsStore.current?.shippingDetails?.description || ""}  ${notifyParty2 ? `\n \n \n*Notify Party 2 -${notifyParty2.toUpperCase()}*` : ""}`;
                                    const numPackages = bookingsStore.current?.shippingDetails?.noOfPieces || item.totNumPackages;
                                    const grossWeight = bookingsStore.current?.shippingDetails?.grossWeightKg || item.totTotalWeight;
                                    const volume = bookingsStore.current?.shippingDetails?.volume || item.totTotalVolume;
                                    setValue(`goods.${index}.marks`, bookingsStore.current?.shippingDetails?.marksAndNumbers);
                                    setValue(`goods.${index}.packages`, bookingsStore.current?.shippingDetails?.externalPack ? `${numPackages} ${packages[bookingsStore.current?.shippingDetails?.externalPack]}` : numPackages);  
                                    setValue(`goods.${index}.description`, descriptionText);
                                    setValue(`goods.${index}.grossWeight`, `${grossWeight} Kgs`);
                                    setValue(`goods.${index}.measurement`, `${volume} CBM`);
                                });
                            loader.hide()
                        }} style={{ color: '#2B6ED4', display: 'flex', gap: '10px', cursor: 'pointer' }}>
                            <img src={fetch} alt="" />
                            <p style={{ fontSize: '14px', fontWeight: '600' }}>Fetch Details</p>
                        </div>

                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.HBL_UPDATE) && <div onClick={handleSubmit((data) => onSubmit(data, 'Update'))} style={{ color: enableButton ? '#D2D1D1' :'#2B6ED4', display: 'flex', gap: '10px', cursor: 'pointer' }}>
                            <img src={enableButton ? updateDisable :update} alt="" />
                            <p style={{
                                fontSize: '14px', fontWeight: '600', fontFamily: 'figtree'
                            }}>Update</p>
                        </div>}

                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.HBL_GENERATE) && <div onClick={handleSubmit((data) => onSubmit(data, 'Save'))} style={{ color: enableButton ? '#D2D1D1' :'#2B6ED4', display: 'flex', gap: '10px', cursor: 'pointer' }}>
                            <img src={enableButton?generateDisable:generate} alt="" />
                            <p style={{ fontSize: '14px', fontWeight: '600',fontFamily: 'figtree'}}>Generate</p>
                        </div>}

                        <div onClick={() =>{
                            if (results?.length > 0 && !enableButton){
                                setOpen(true)
                            }
                        }} style={{ color: !enableButton && results?.length > 0 ? '#2B6ED4' :'#D2D1D1', display: 'flex', gap: '10px', cursor: 'pointer' }}>
                            <img src={!enableButton && results?.length > 0 ? log : historyDisable} alt="" />
                            <p style={{ fontSize: '14px', fontWeight: '600', fontFamily: 'figtree' }}>Log History</p>
                        </div>

                        {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_FINAL) && finalEditable && hblDetailsStore.current?.blData?.type === "Generated" && hblDetailsStore.current?.blData?.status === "Final") && <div onClick={(e)=>{
                            e.preventDefault()
                            setPopupMessage("Are you sure you want to edit the finalized HBL?")
                            setOpenPopup(true)
                            setType("Final")
                        }} style={{ color: enableButton ? '#D2D1D1' :'#2B6ED4', display: 'flex', gap: '10px', cursor: 'pointer' }}>
                            <img src={EditIcon} alt="" />
                            <p style={{ fontSize: '14px', fontWeight: '600',fontFamily: 'figtree'}}>Edit Final</p>
                        </div>}

                        <div
                          style={{
                            marginLeft: "auto",
                            display: "flex",
                            background: "#FCFCFC",
                            padding: "4px",
                            borderRadius: "6px",
                            width: "160px",
                            border: "1px solid #E5E5E5",
                          }}
                        >
                        <input type="hidden" {...register("status", { required: true })} />
                          {statusArray.map((item) => (
                            <div
                              key={item}
                              onClick={() => {
                                if (finalEditable) return;
                                if (item === "Final") {
                                  const entityId = bookingsStore.current?.contract?.entityId || bookingsStore.current?.entityId || myactionsstore?.list?.[0]?.booking?.entityId || myactionsstore?.list?.[0]?.Entities?._id;
                                  const shipmentType = bookingsStore.current?.contract?.shipmentType || bookingsStore.current?.shipmentType || myactionsstore?.list?.[0]?.shipmentType;
                                  if (creditControlStore.isHoldBLDO(entityId, shipmentType)) {
                                    configStore.setModalMessage("Finance Hold is applicable for BL/DO release", [], false);
                                    return;
                                  }
                                }
                                setValue("status", item);
                                if(item === 'Draft'){
                                   setValue('blType', "")
                                   setValue('sob', "")
                                   clearErrors()
                                }
                              }}                          
                              style={{
                                flex: 1,
                                padding: "6px",
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: 500,
                                cursor: "pointer",
                                borderRadius: "6px",
                                background:
                                  status === item ? "#EB9338" : "transparent",
                                color:
                                  status === item ? "#FFFFFF" : "#333333",
                              }}
                            >
                              {item}
                            </div>
                          ))}
                        </div>
                    </div>


                    <div style={{
                        display: 'flex',
                        gap: '30px',
                        padding: '0 40px',
                        alignItems: 'center'
                    }}>
                        {
                            status === 'Final' ?
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ fontSize: '13px', color: '#2B3688', marginBottom: '5px', fontWeight: '400', fontFamily: 'figtree' }}>BL Type</label>
                                    <select
                                        {...register('blType',{required:"BL Type is Required"})}
                                        disabled={finalEditable}
                                        onClick={(e)=>{
                                            if(blType !== 'Original'){
                                                setValue('originalMtd', "0 (Zero)")
                                            }                                            
                                        }}
                                        style={{
                                            width: '250px',
                                            padding: '8px',
                                            outline: "none",
                                            // backgroundColor: "white",
                                            border: errors.blType
                                            ? "1px solid red"
                                            : "1px solid #DDDDDD"
                                        }}
                                    >
                                        <option value="">Select an option</option>
                                        <option value="Express">Express</option>
                                        <option value="Seaway">Seaway</option>
                                        <option value="Telex">Telex</option>
                                        <option value="Original">Original</option>
                                        <option value="RFS">RFS</option>
                                    </select>
                                </div> : <></>
                        }

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '13px', color: '#2B3688', marginBottom: '5px', fontWeight: '400', fontFamily: 'figtree' }}>HBL Date</label>
                            <input
                                {...register('hblDate')}
                                type="date"
                                disabled={finalEditable}
                                style={{
                                    width: '250px',
                                    padding: '8px',
                                    border: '1px solid #DDDDDD'
                                }}

                            />
                        </div>

                        {(blType !== "RFS" && status === 'Final') && (<div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '13px', color: '#2B3688', marginBottom: '5px', fontWeight: '400', fontFamily: 'figtree' }}>
                                Shipped on Board Date
                            </label>
                            <input
                                {...register(
                                  "sob",
                                //   (blType !== "RFS")
                                //     ? 
                                {
                                    required: "Shipped on Board Date is Required"
                                }
                                //     : {}
                                )}                                
                                type="date"
                                disabled={finalEditable}
                                style={{
                                    width: '250px',
                                    padding: '8px',
                                    // backgroundColor: "white",
                                    border: errors.sob
                                    ? "1px solid red"
                                    : "1px solid #DDDDDD" 
                                }}
                            />
                        </div>)}

                        {/* <div style={{ marginTop: '18px' }}>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                                style={{
                                    backgroundColor: '#2B6ED4',
                                    color: 'white',
                                    border: 'none',
                                    padding: '9px 18px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontFamily: 'figtree'
                                }}
                            >
                                Stamp Clause
                            </button>
                        </div> */}

                    </div>
                </div>
                {/* Consignor */}
                <div style={row}>
                    <Field label="Consignor" name="consignorAddress" type="textarea" />
                    <Field label="MTD NO" name="mtdNo" disabled={true} />
                </div>

                {/* Consignee */}
                <div style={row}>
                    <Field label="Consignee" name="consigneeAddress" type="textarea" />
                    {/* <Field label="MTO Registration Number" name="mtoNo" /> */}
                </div>

                {/* Notify */}
                <div style={row}>
                    <Field label="Notify Party" name="notifyParty1" type="textarea" />
                    <Field label="Modes of Transport" name="mode" />
                    {/* <Field label="Notify Party 2" name="notifyParty2" type="textarea" /> */}
                </div>

                {/* Vessel */}
                <div style={row}>
                    <Field label="Vessel" name="vessel"/>
                    <Field label="Place of Acceptance" name="placeOfAcceptance" />
                    <Field label="Place of Transhipment" name="transhipment" />
                    <Field label="Final Place of Delivery" name="fpod" />
                </div>

                <div style={row}>
                    <Field label="Voyage" name="voyage"/>
                    <Field label="Port of Loading" name="pol" />
                    <Field label="Place of Delivery" name="pod" />
                    <Field label="Movement" name="movement" />
                </div>

                {/* Dates */}
                {/* <div style={row}> */}
                    {/* <Field label="Date of Acceptance" name="doa" /> */}
                    {/* <Field label="Date of Period of Delivery" name="deliveryDate" /> */}
                    {/* <Field label="Modes of Transport" name="mode" /> */}
                {/* </div> */}

                <div style={row}>
                    <Field label="Marks and Nos Container and Seals" name="goods[0].marks" type="textarea"  headerStyle={{ height: "60px" }} />
                    <Field label="No and Kind of Packages" name="goods[0].packages" type="textarea"  headerStyle={{ height: "60px" }} />
                    <Field label="Description of Packages and Goods as stated by shipper
                 Shipper's Load stow and count said to contain" name="goods[0].description" type="textarea"  headerStyle={{ height: "60px" }} />
                    <Field label="Gross Weight" name="goods[0].grossWeight" type="textarea"  headerStyle={{ height: "60px" }}/>
                    <Field label="Measurements" name="goods[0].measurement" type="textarea"  headerStyle={{ height: "60px" }}/>
                </div>

                {/* Particulars */}
                {/* <div style={row}>
                    <Field label="Particulars above Furnished by Consignor/Consignee" name="particulars" />
                </div> */}

                {/* Destination */}
                <div style={row}>
                    <Field label="Destination Agent Address" name="destinationAddress" type="textarea"/>
                    {/* <Field label="Additional Clauses" name="additionalClauses" /> */}
                </div>

                <div style={row}>
                    <Field label="Number of Original MTD" name="originalMtd" style={{height:'20px'}} type="dropdown"  />
                    <Field label="Place and Date of Issue" name="dateAndPlaceOfIssue" style={{height:'20px'}} />
                </div>

                {/* Original */}
                {/* <div style={row}> */}
                    {/* <Field label="Number of Original MTD" name="originalMtd" /> */}
                    {/* <Field label="Other Particulars (If Any)" name="otherDetails" /> */}
                {/* </div> */}

                {/* Issue */}
                {/* <div style={row}> */}
                    {/* <Field label="Place and Date of Issue" name="dateAndPlaceOfIssue" /> */}
                    {/* <Field label="Signed for Byteport Logistics Technologies Pvt Ltd" name="signed" style={{ borderBottom: 'none' }} /> */}
                {/* </div> */}

                {/* Freight */}
                {/* <div style={row}>
                    <Field label="Freight Amount" name="freightAmount" />
                    <div style={{ ...box, flex: 1, borderTop: 'none' }}></div>
                </div> */}

                {/* Buttons */}
                {/* <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '25px' }}>
                    <button style={{ backgroundColor: '#DB4747', color: "#fff" }} className="button">
                        Cancel
                    </button>
                    <button style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff" }} className="button">
                        Generate
                    </button>
                </div> */}

            </form>
        </div>
    </>);
}


export function LogHistory({ onClose, data }) {
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
        },
        modal: {
            width: "750px",
            background: "#fff",
            borderRadius: "10px",
            padding: "25px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
        },
        title: {
            fontSize: "20px",
            fontWeight: "600",
            color: "#2d3a8c",
            fontFamily: 'figtree'
        },
        closeBtn: {
            cursor: "pointer",
            fontSize: "18px",
            border: "none",
            background: "none",
            fontFamily: 'figtree'
        },
        tableHeader: {
            display: "flex",
            padding: "10px 0",
            borderBottom: "1px solid #ddd",
            fontWeight: "600",
            fontFamily: 'figtree'
        },
        row: {
            display: "flex",
            padding: "12px 0",
            borderBottom: "1px solid #eee",
        },
        col1: { flex: 2 },
        col2: { flex: 2 },
        col3: { flex: 1 },
    };
    return (
        <div style={styles.overlay} onClick={() => onClose(false)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.title}>Log History</div>
                    <button style={styles.closeBtn} onClick={() => onClose(false)}>
                        ✕
                    </button>
                </div>

                {/* Table Header */}
                <div style={styles.tableHeader}>
                    <div style={styles.col1}>Generated by</div>
                    <div style={styles.col2}>Generated at</div>
                    <div style={styles.col3}>Status</div>
                </div>
                <div style={{ maxHeight: "290px", overflowY: "auto", }}>
                {/* Rows */}
                {data?.filter(e=>e.blData.status && e.blData.type === 'Generated').map((log, index) => (
                    <div key={index} style={styles.row}>
                        <div style={styles.col1}>{log.tsCreatedBy}</div>

                        <div style={styles.col2}>{Utils.formatToDateTime(Number(log.tsCreatedOn))}</div>

                        <div
                            style={{
                                ...styles.col3,
                                color: log.blData.status === "Final" ? "#2563eb" : "#f97316",
                                fontWeight: 500,
                            }}
                        >
                            {log.blData.status === "Final" ? `${log.blData.status} (${log.blData.blType})`  : log.blData.status }
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </div>
    );
}

export function Popup({ message, onClose,type = "",finalEditable }) {
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
        },

        modal: {
            width: "520px",
            background: "#fff",
            borderRadius: "12px",
            padding: "40px 30px",
            textAlign: "center",
            position: "relative",
            boxShadow: "0 4px 25px rgba(0,0,0,0.2)"
        },

        close: {
            position: "absolute",
            top: "15px",
            right: "18px",
            fontSize: "20px",
            cursor: "pointer",
            border: "none",
            background: "none"
        },

        message: {
            fontSize: "18px",
            color: "#333",
            lineHeight: "28px",
            marginBottom: "35px",
            fontFamily: 'figtree'
        },

        button: {
            background: "#3a4694",
            color: "#fff",
            border: "none",
            padding: "10px 30px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "16px",
            fontFamily: 'figtree'
        }
    };

    return (
        <div style={styles.overlay} onClick={() => onClose(false)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

                {type === "" && <button style={styles.close} onClick={() => onClose(false)}>
                    ✕
                </button>}

                <div style={styles.message}>{message}</div>

                {type === "" && (
                    <button style={styles.button} onClick={() => onClose(false)}>
                        Done
                    </button>
                )}
                {type === "Final" && (
                    <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                    <button style={{border: "1px solid black/400 #878787",background: "transparent",padding: "10px 30px",borderRadius: "6px",cursor: "pointer",fontSize: "16px",fontFamily: 'figtree'}} 
                     onClick={() => onClose(false)}>
                        No
                    </button>
                    <button style={{background: "#2B3688",color: "#E6F0FF",border: "none",padding: "10px 30px",borderRadius: "6px",cursor: "pointer",fontSize: "16px",fontFamily: 'figtree'}}
                     onClick={() => {
                        finalEditable(false)
                        onClose(false)
                     }}>
                        Yes
                    </button>
                    </div>
                )}

            </div>
        </div>
    );
}